import React from 'react';
// import { withStyles, } from '@material-ui/core/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { Fade, LinearProgress } from '@mui/material';


export default function ControlBar(props) {
    const {loading, style} = props

    return (
        <React.Fragment>
            <Paper
                style={{...style}}
                sx={{
                backgroundColor: 'rgba(0,0,0,0.55)',
                color: 'white', // Text color
                }}>
                
                <Box
                display="flex" 
                minHeight="47px"
                maxHeight="auto"
                width='100%'
                >
                    <Box 
                    display="flex" 
                    flexDirection='row'
                    alignItems="center"
                    justifyContent='safe center'
                    width='100%'
                    height='100%'
                    >
                        {props.children}
                    </Box>
                </Box>
                <Fade
                    in={loading}
                    style={{
                        transitionDelay: loading ? '800ms' : '0ms',
                    }}
                    unmountOnExit
                    >
                    <LinearProgress color="success" />
                </Fade>
            </Paper>
        </React.Fragment>
    )
}